export default __webpack_public_path__ + "static/media/sa4.fd4a9a49.jpg";